// extracted by mini-css-extract-plugin
export var Banner = "banner-module--Banner--1lu16";
export var Banner__body = "banner-module--Banner__body--10eNV";
export var Banner__label = "banner-module--Banner__label--2jLoK";
export var Banner__link = "banner-module--Banner__link--cHtr9";
export var Banner__title = "banner-module--Banner__title--u-8Nf";
export var Banner__location = "banner-module--Banner__location--24au_";
export var Banner__interval = "banner-module--Banner__interval--55CCU";
export var Banner__close = "banner-module--Banner__close--3ZJYb";